import { useState, useEffect } from "react";
import { API, graphqlOperation } from "aws-amplify";
import * as mutations from "../../graphql/mutations";
import { useNavigate, useParams } from "react-router-dom";
import "./EditPolicy.css";
import { InputForm } from "../InputForm/InputForm";
import { Button } from "react-bootstrap";
import { Checkbox } from "../Checkbox/Checkbox";
import { getPolicyById } from "../../graphql/queries";
import { PolicyType } from "../PrivacyPolicy/PrivacyPolicType";
import { getPolicyByIdType } from "./EditPolicyTypes";
import { GraphQLResult } from "@aws-amplify/api-graphql";
import { Notification } from "../Notification/Notification";
import { Modal } from "../Modal/Modal";
import Select from "react-select";

export const EditPolicy = () => {
  const [policy, setPolicy] = useState({} as PolicyType);
  const [defaultLabel, setDefaultLabel] = useState("");
  const { id } = useParams();
  const [policyLoaded, setPolicyLoaded] = useState(false);
  const [toastTitle, setToastTitle] = useState("" as string);
  const [toastDescription, setToastDescription] = useState("" as string);
  const [showToast, setShowToast] = useState(false as boolean);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);

  type OptionType = {
    value: string;
    label: string;
  };

  const options: OptionType[] = [
    {
      value: "ti",
      label: "Travel Insurance",
    },
    { value: "tmc", label: "Travel Money Card" },
    { value: "app", label: "Travel App" },
  ];

  const handlePolicy = async () => {
    try {
      const policyById = (await API.graphql(
        graphqlOperation(getPolicyById, {
          policyId: id,
        })
      )) as GraphQLResult<getPolicyByIdType>;
      console.log(policyById);
      const policyData = policyById?.data?.getPolicyById;
      selectLabel(policyById?.data?.getPolicyById.policyType);
      setPolicy(policyData);
      setPolicyLoaded(true);
    } catch (e) {
      console.log(e);
    }
  };

  const handleChangeText = (value: string, name: string) => {
    setPolicy((policy) => {
      return {
        ...policy,
        [name]: value,
      };
    });
  };

  const handleDescription = (event) => {
    let newBody = event.target.value;
    setPolicy((policy) => {
      return {
        ...policy,
        body: newBody,
      };
    });
  };

  const handleSelectChange = (selected) => {
    setPolicy((policy) => {
      return {
        ...policy,
        policyType: selected.value,
      };
    });
  };

  const handleOpenDeleteModal = () => {
    setShowDeleteModal(true);
  };

  const handleCloseDeleteModal = () => {
    setShowDeleteModal(false);
  };

  const handleOpenEditModal = () => {
    setShowEditModal(true);
  };

  const handleCloseEditModal = () => {
    setShowEditModal(false);
  };

  const handleCheckValue = (event: React.MouseEvent<HTMLInputElement>) => {
    const currentTarget = event.target as HTMLInputElement;
    const checked = currentTarget.checked;
    const name = currentTarget.name;
    setPolicy((policy) => {
      return {
        ...policy,
        [name]: checked,
      };
    });
  };

  const handleNotificationClose = () => {
    setShowToast(false);
  };

  const selectLabel = (policyType) => {
    if (policyType === "ti") {
      setDefaultLabel(options[0].label);
    }
    if (policyType === "tmc") {
      setDefaultLabel(options[1].label);
    }
    if (policyType === "app") {
      setDefaultLabel(options[2].label);
      console.log("setting label");
    }
  };

  const navigate = useNavigate();

  const goBack = () => {
    navigate(-1);
  };

  useEffect(() => {
    handlePolicy();
  }, []);

  const handleUpdatePolicy = async () => {
    try {
      console.log("Policy update: " + JSON.stringify(policy));
      await API.graphql(
        graphqlOperation(mutations.updatePolicy, {
          policy,
        })
      );
      console.log("Updated policy");
      setToastTitle("Policy Successfully Updated");
      setToastDescription(
        `Policy with header ${policy.header} has been updated successfully`
      );
      setShowEditModal(false);
      setShowToast(true);
    } catch (e) {
      console.log(e);
    }
  };

  const handleDeletePolicy = async (id: string) => {
    try {
      await API.graphql(
        graphqlOperation(mutations.deletePolicy, {
          policyId: id,
        })
      );
      setShowDeleteModal(false);
      setShowToast(true);
      setToastTitle("Policy Deleted");
      setToastDescription(
        `Policy with header ${policy.header} has been deleted`
      );
      const navTimer = setTimeout(() => {
        navigate(-1);
      }, 4000);
      return () => clearTimeout(navTimer);
    } catch (e) {
      console.log(e);
    }
  };

  return (
    <div style={{ flex: 1 }}>
      <h1 className="title">Edit Existing Policy</h1>
      {policyLoaded ? (
        <div className="formContainer">
          <div className="formItem">
            <InputForm
              name="header"
              ariaLabel="Title"
              size="lg"
              onChange={handleChangeText}
              labelText="Policy Header"
              controlId="formMessages"
              defaultValue={policy?.header}
            />
          </div>
          <div className="formItem">
            <div className="description-title">Select Policy Type</div>
            <Select
              defaultValue={{
                value: policy.policyType,
                label: defaultLabel,
              }}
              options={options}
              onChange={handleSelectChange}
            />
          </div>
          <div className="formItem">
            <div className="description-title">Policy Body</div>
            <textarea
              value={policy.body}
              className="description"
              onChange={handleDescription}
              defaultValue={policy?.body}
            />
          </div>
          <div className="formItem">
            <span>
              <Checkbox
                label="Is Active"
                name="isActive"
                handleCheck={handleCheckValue}
                defaultChecked={policy?.isActive}
              />
            </span>
          </div>
          <div className="formItem">
            <Button
              type="button"
              className="btn btn-danger save-button"
              onClick={() => handleOpenEditModal()}
            >
              Save
            </Button>
            <Button
              type="button"
              className="btn btn-warning save-button"
              onClick={() => handleOpenDeleteModal()}
            >
              Delete
            </Button>
            <Button
              type="button"
              className="btn btn-secondary"
              onClick={goBack}
            >
              Cancel
            </Button>
          </div>
        </div>
      ) : null}
      <div className="notificationContainer">
        <Notification
          show={showToast}
          timer={50000}
          position="bottom-end"
          title={toastTitle}
          description={toastDescription}
          autohide={true}
          handleClose={handleNotificationClose}
        />
      </div>
      <Modal
        enableModal={showDeleteModal}
        handleClose={handleCloseDeleteModal}
        handleSubmit={() => handleDeletePolicy(id)}
        title={"WARNING"}
        closeButtonText="Back"
        actionButtonText="Delete"
        width="halfwidth"
      >
        Are you sure you would like to delete this policy? Once it has been
        deleted this cannot be reversed
      </Modal>
      <Modal
        enableModal={showEditModal}
        handleClose={handleCloseEditModal}
        handleSubmit={() => handleUpdatePolicy()}
        title={"Editing Policy"}
        closeButtonText="Back"
        actionButtonText="Edit"
        width="halfwidth"
      >
        Are you sure you would like to edit this policy?
      </Modal>
    </div>
  );
};
